// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__BVO9D","requiredAsterisk":"Info_requiredAsterisk__zHqG_"};